export const formatPrice = (value) => {
  // Gracefully handle empty / nullish values
  if (value === null || value === undefined || value === "") return "0.00";

  // Normalize value: remove commas/spaces and cast to number
  const normalized = String(value).replaceAll(",", "").trim();
  const num = Number(normalized);

  if (Number.isNaN(num)) {
    return "0.00";
  }

  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    // style: "currency",
    // currency: "EGP",
  }).format(num);
};
